import { useForm } from 'react-hook-form'
import { Button, TextField } from '@mui/material'
import { toast } from 'react-toastify'
import { queryClient } from 'queryClient'
import { Event } from 'interfaces/entities/event.model'
import eventsService from 'services/admin/eventsService'
import { useGetTicketEvents } from 'hooks/useGetTicketEvents'
import { TicketEventItem } from './TicketEventItem'

interface TicketEventsProps {
    ticketID: number | string
}

export const TicketEvents = ({ ticketID }: TicketEventsProps) => {
    const ticketIDStr = String(ticketID)
    const { data: events } = useGetTicketEvents(ticketIDStr)
    const { register, handleSubmit, reset } = useForm({
        defaultValues: {
            text: '',
        },
        mode: 'onChange',
    })

    const onSubmit = async (data: any) => {
        try {
            if (!data.text || !data.text.trim()) {
                toast.error('Комментарий не может быть пустым!')
                return
            }
            if (data.text.trim().length < 3) {
                toast.error('Комментарий должен быть больше 3 символов!')
                return
            }
            const eventInput = {
                ticketID: ticketIDStr,
                eventType: 'COMMENT_ADDED',
                payload: {
                    text: data.text,
                },
            }
            await eventsService.addEvent(eventInput)
            toast.success('Комментарий добавлен успешно!')
            queryClient.invalidateQueries({ queryKey: ['events', 'ticket', ticketIDStr] })
            reset()
        } catch (error) {
            console.error(error)
            toast.error('Ошибка при добавлении комментария!')
        }
    }

    return (
        <div>
            <div className='flex flex-col gap-2'>
                <TextField
                    multiline
                    rows={3}
                    label='Комментарий'
                    {...register('text')}
                    fullWidth
                />
                <Button
                    type='button'
                    variant='outlined'
                    color='primary'
                    onClick={handleSubmit(onSubmit)}
                >
                    Отправить
                </Button>
            </div>
            <div className='flex flex-col gap-2 mt-6'>
                {(events as Event[] | undefined)?.map((event) => (
                    <div key={event.id}>
                        <TicketEventItem event={event} />
                    </div>
                ))}
                {(!events || events.length === 0) && (
                    <div className='text-sm text-gray-500'>Действий пока нет</div>
                )}
            </div>
        </div>
    )
}
